// 准星接口
export const FLIGHTSZHUNXINGAPI = 'https://res.xiaojukeji.com/resapi/activity/mget'